import { NavigationBar } from "./navigationBar/NavigationBar";
import styled from "styled-components";


const Container = styled.div`
  margin-top: 60px;
`;
const Wrapper = styled.div`
  padding: 0 40px;
`;

export const PageLayout = (props) => {
  
  return (
    <Container>
      <NavigationBar />

      <Wrapper>{props.children}</Wrapper>
      {/* <ErrorAlert handleClose={handleClose} open={open} errorMessage={error} /> */}
    </Container>
  );
};
